export default "__VITE_ASSET__SIH2vN5___"